import Styled from 'styled-components';
import {CSS_CONSTANTS} from '../../../../../css_variables';

export const PreviewSelector = Styled.div`
	font-size: 9px;
	.dropdown-container {
	    height: 40px;
	    > div {
	        padding: 0;
	    }
	}
	input {
        padding: 10px 30px 10px 16px;
	)
`;

export const DropdownOption = Styled.div`
    display: flex;
    justify-content: space-between;
	align-items: center;
`;

export const FlexGroup = Styled.div`
    display: flex;
	align-items: center;
	column-gap: 6px;
`;

export const HoverShow = Styled.div`
	visibility: hidden;
`;

export const Item = Styled.div`
	font-size: 11px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 6px 10px 6px 4px;
	&:hover {
        background-color: ${CSS_CONSTANTS.background_ghost_white};
        ${HoverShow} {
			visibility: visible;
        }
    }
`;

export const ItemName = Styled.div`
	font-size: 13px;
	font-weight: 500;
`;

export const ItemDescription = Styled.div`
	color: #545454;
`;

export const ItemWarning = Styled.div`
	color: #FD3027;
`;

export const ItemNote = Styled.div`
    color: #A5A5AE;
`;

export const Selections = Styled.div`
	margin-top: 20px;
`;

export const SelectionsHeader = Styled.div`
    display: flex;
    justify-content: space-between;
    align-items: end;
    margin-bottom: 5px;
`;

export const SelectionsHeaderActions = Styled.div`
    display: flex;
    flex-direction: row;
    justify-content: right;
    
    .dropdown-container {
        height: 24px;
        width: 130px;
        border: 1px solid transparent;
        :hover, :focus, :active {
            border: 1px solid ${CSS_CONSTANTS.v2_button_very_light_grey};
        }
        input {
            padding: 0;
        }
        input, p {
            text-align: center;
        }
    }
    
    .search-V2 {
        height: 24px;
        min-width: 24px;
        padding: 0 24px 0 0;
        margin-right: 0;
        background-size: 14px;
        background-position: right 5px center;
        border: 1px solid transparent;
	    border-radius: 4px;
        
        :hover, &.expanded {
            border: 1px solid ${CSS_CONSTANTS.v2_button_very_light_grey};
        }
        
        input {
            padding: 4px 0 0 6px;
            font-size: 12px;
            width: 100px;
        }
    }
`;
